import React from 'react'
import { Flex } from 'styling/GlobalStyles'
import { Heading1, SmallText, TinyText } from 'styling/TypographyV2'
import { KpiCardContainer, KpiIconBox } from '../Organogram.styled'

interface KpiCardProps {
  icon: React.ReactNode
  value: number
  label: string
  sublabel?: string
  accentColor: string
}

export const KpiCard = ({ icon, value, label, sublabel, accentColor }: KpiCardProps) => {
  return (
    <KpiCardContainer accentColor={accentColor}>
      <KpiIconBox accentColor={accentColor}>{icon}</KpiIconBox>
      <Flex column gap='0.125rem'>
        <Heading1>{value}</Heading1>
        <SmallText uppercase semibold>
          {label}
        </SmallText>
        {sublabel && <TinyText>{sublabel}</TinyText>}
      </Flex>
    </KpiCardContainer>
  )
}
